/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, {useState, useRef, useEffect} from 'react';
import _ from 'lodash';
import ClickOut from 'react-click-out';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {
  ILink,
  IProd,
  IState,
  LocationCategory,
  ProductCategory,
  Replacement,
} from '../../../interface';
import {connect, useSelector} from 'react-redux';
import localesReplacement from '../../../utils/localesReplacement';
import {Dispatch} from 'redux';
import actions from '../../../redux/actions';
import {productClickLogs} from '../../../services';
import {ANALYTICS_BUTTON_NAME, ANALYTICS_EVENT, ANALYTICS_PAGE_TYPE, APPNAME, FASTSCAN, MAP_PROD_TO_LOCA} from '../../../constants';
import { Variant } from '../../../constants/variants';
import {useSearchParams} from 'react-router-dom';
import {useAppName} from '../../../hooks/use-app-names';
import publicImage from '../../../utils/publicImage';
import {PageType} from '../../../interface/emnu';
import { useAnalytics } from '../../../hooks/use-analytics';

import Zoom from '../Zoom';

const cx = classnames.bind(style);

interface IProps {
  withoutMoreLink: boolean;
  dataList: Partial<IProd>;
  setProductCategories: (value: string[]) => void;
  setLocationCategories: (value: string[]) => void;
  replacements: Replacement;
  moreLinkClick?: () => void;
  whereToBuyEnabled: boolean | null;
  whereToServiceEnabled: boolean | null;
  onPrintClick?: any;
  locationCategoriesList: LocationCategory[] | null;
  productCategoriesList: ProductCategory[] | null;
  products?: any;
  vehicleP?: any;
  componentName?: any;
  Recommendation?: string;
  withoutLinks?: boolean;
  maxSize?: number;
  onlyThumb?: boolean;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const OilThumb = (props: IProps) => {
  const {
    withoutMoreLink,
    dataList,
    setProductCategories,
    setLocationCategories,
    replacements,
    moreLinkClick,
    whereToBuyEnabled,
    whereToServiceEnabled,
    onPrintClick,
    locationCategoriesList,
    productCategoriesList,
    products,
    vehicleP,
    Recommendation,
    componentName,
    withoutLinks,
    maxSize,
    onlyThumb,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const vehicle = useSelector((state: any) => state.filter.vehicle);

  const [searchParams, setSearchParams] = useSearchParams();
  const [visible, setVisible] = useState<boolean>(false);
  const [position, setPosition] = useState<string>('');
  const [visibleMarketing, setVisibleMarketing] = useState<boolean>(false);
  const [positionMarketing, setPositionMarketing] = useState<string>('');
  const ref = useRef<HTMLDivElement>(null);
  const sendAnalytics = useAnalytics();
  const variant = searchParams.get('variant');
  const isFord = variant === Variant.FORD;
  useEffect(() => {
    const h =
      ref.current &&
      ref.current?.getBoundingClientRect().height +
        ref.current?.getBoundingClientRect().y;
    _.toNumber(h) > document.documentElement.clientHeight
      ? setPosition('bottom')
      : setPosition('top');

    _.toNumber(h) > document.documentElement.clientHeight
      ? setPositionMarketing('top')
      : setPositionMarketing('bottom');
  }, [visible, visibleMarketing]);
  const redirect = () => {
    moreLinkClick && moreLinkClick();
  };
  const window: any = globalThis;
  const whereToBuy = (productCategoryId: number, oilName?: any) => {
    if (dataList.id) {
      if (Recommendation === PageType.ProductPage) {
        sendAnalytics({
          event: ANALYTICS_EVENT.WHERE_TO_BUY_CLICK ,
          page: ANALYTICS_PAGE_TYPE.PRODUCT_PAGE,
          button: ANALYTICS_BUTTON_NAME.WHERE_TO_BUY,
          oilName: products?.name,
          oilCategory: componentName,
          model: `${vehicle?.make} ${vehicle?.model}`,
          country: localStorage.getItem('countryCode') || '',
        });
      } else {
        sendAnalytics({
          event: ANALYTICS_EVENT.WHERE_TO_BUY_CLICK ,
          page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
          button: ANALYTICS_BUTTON_NAME.WHERE_TO_BUY,
          recommendation: Recommendation,
          oilName: oilName.name,
          oilCategory: componentName, //products?.name + " " + products?.code,
          model: `${vehicleP?.make} ${vehicleP?.model}`,
          country: localStorage.getItem('countryCode') || '',
        });
      }

      productClickLogs({
        productId: dataList.id,
        type: 'Where to Buy',
      }).then(() => {
        setProductCategories([productCategoryId.toString()]);
        // setLocationCategories(['3']);
        searchParams.set('page', 'wheretobuy');
        isFastScan && searchParams.set(APPNAME, FASTSCAN);
        setSearchParams(searchParams);
      });
    }
  };

  const whereToService = (productCategoryId: number, oilName?: any) => {
    if (dataList.id) {
      if (Recommendation === PageType.ProductPage) {
        sendAnalytics({
          event: ANALYTICS_EVENT.WHERE_TO_SERVICE_CLICK ,
          page: ANALYTICS_PAGE_TYPE.PRODUCT_PAGE,
          button: ANALYTICS_BUTTON_NAME.WHERE_TO_SERVICE,
          oilName: products?.name,
          country: localStorage.getItem('countryCode') || '',
        });
      } else {
        sendAnalytics({
          event: ANALYTICS_EVENT.WHERE_TO_SERVICE_CLICK ,
          page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
          recommendation: Recommendation,
          button: ANALYTICS_BUTTON_NAME.WHERE_TO_SERVICE,
          oilName: oilName?.name,
          oilCategory: componentName, //products?.name + " " + products?.code,
          model: `${vehicleP?.make} ${vehicleP?.model}`,
          country: localStorage.getItem('countryCode') || '',
        });
      }

      productClickLogs({
        productId: dataList.id,
        type: 'Where to Service',
      }).then(() => {
        const productName =
          _.find(productCategoriesList, ['id', productCategoryId])?.name ?? '';
        const locationName = _.get(MAP_PROD_TO_LOCA, productName);
        setProductCategories([productCategoryId.toString()]);
        setLocationCategories(
          _.chain(locationCategoriesList)
            .filter(['name', locationName])
            .map((it) => it.id.toString())
            .value(),
        );
        searchParams.set('page', 'wheretobuy');
        isFastScan && searchParams.set(APPNAME, FASTSCAN);
        setSearchParams(searchParams);
      });
    }
  };
  const openLink = (linkData: ILink) => {
    const element = document.querySelector('#external-link-popover');
    if (element) {
      element.dataset.link = linkData.link;
    }
    // if (dataList.id) {
    //   sendAnalytics({
    //     event: ANALYTICS_EVENT.BUY_ONLINE_CLICKS ,
    //     page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
    //     recommendation: Recommendation,
    //     button: ANALYTICS_BUTTON_NAME.BUY_ONLINE_BUTTON_PREFIX  + linkData.displayText,
    //     oilName: products?.name,
    //     oilCategory: `${products?.name} ${products?.code}`,
    //     model: `${vehicleP?.make} ${vehicleP?.model}`,
    //     country: localStorage.getItem('countryCode') || '',
    //   });
    //   productClickLogs({
    //     productId: dataList.id,
    //     type: 'Link',
    //     linkId: linkData.id,
    //   }).then(() => {
    //     window.open(linkData.link, '_blank');
    //   });
    // }
  };

  const navigateToTurkyWhereToBuy = () => {
    window.open('/tr_tr/turkey/home/nereden-alabilirim.html');
  };

  const image = 'packartUrl' in dataList ? dataList.packartUrl : dataList.thumb || publicImage('no-image.png');

  return (
    <>
      <div
        className={`${cx('thumbnail', {'no-link': withoutMoreLink})}`}
        style={{width: maxSize, maxWidth: maxSize}}
      >
        {
          <div>
            <Zoom
              image={image}
              alt={dataList.name} />
          </div>
        }
      </div>
      {!onlyThumb && (
        <>
          {!!vehicle && !!onPrintClick && (
            <div className={`${cx('print-buttons')} ${cx('buttons')}`}>
              <a
                className={`primary-link ${cx('print')}`}
                onClick={onPrintClick}
              >
                {localesReplacement(replacements, 'Print')}
              </a>
            </div>
          )}
          {!withoutMoreLink && (
            <div className={cx('more-link')}>
              <span role='link' className='primary-link' onClick={redirect}>
                {localesReplacement(replacements, 'More information')}
              </span>
            </div>
          )}
          {dataList.links && !isFastScan && !withoutLinks && !isFord && (
            <div className={cx('buttons')}>
              {!!whereToBuyEnabled && (
                <button
                  className={`primary-button ${cx('where-to-buy')}`}
                  onClick={() => {
                    const countryCode = localStorage.getItem('countryCode');
                    if (countryCode && countryCode === 'TUR') {
                      navigateToTurkyWhereToBuy();
                    } else {
                      whereToBuy(
                        dataList.productCategoryId as number,
                        dataList,
                      );
                    }
                  }}
                  key='wtb'
                >
                  {localesReplacement(replacements, 'Where to buy')}
                </button>
              )}
              {!!whereToServiceEnabled && (
                <button
                  className={`primary-button ${cx('where-to-service')}`}
                  onClick={() =>
                    whereToService(
                      dataList.productCategoryId as number,
                      dataList,
                    )
                  }
                  key='wts'
                >
                  {localesReplacement(replacements, 'Where to service')}
                </button>
              )}

              {!!dataList.links.filter((x) => x.isMarketing === false).length &&
                !isFastScan && (
                  <>
                    <div className={cx('mask', {visible: visible})}></div>
                    {dataList.links.length > 1 ? (
                      <ClickOut
                        className={cx('trigger')}
                        onClickOut={() => {
                          setVisible(false);
                        }}
                      >
                        <>
                          <button
                            className={`primary-button ${cx('shop-online')}`}
                            onClick={() => setVisible(!visible)}
                          >
                            {localesReplacement(replacements, 'Shop online')}
                          </button>

                          <div
                            className={cx(
                              'flyout',
                              {visible: visible},
                              position,
                            )}
                            ref={ref}
                          >
                            <div className={cx('caption')}>{localesReplacement(replacements, 'Shop online')}</div>
                            <ul>
                              {_.sortBy(
                                dataList.links,
                                (o) => o.displayText,
                              ).map(
                                (item) =>
                                  !item.isMarketing && (
                                    <li key={item.id} className={cx('shop-item')}>
                                      <button
                                        popovertarget="external-link-popover"
                                        popoveraction="show"
                                        onClick={() => {
                                          openLink(item);
                                          setVisible(false);
                                        }}
                                        rel='noreferrer'
                                        target='_blank'
                                        className={`${cx('shop-online-item')}`}
                                      >
                                        {localesReplacement(
                                          replacements,
                                          item.displayText,
                                        )}
                                      </button>
                                    </li>
                                  ),
                              )}
                            </ul>
                          </div>
                        </>
                      </ClickOut>
                    ) : (
                      <button
                        className={`primary-button ${cx(
                          'shop-online',
                          'no-icon',
                        )}`}
                        popovertarget="external-link-popover"
                        popoveraction="show"                        
                        onClick={() =>
                          openLink(_.head(dataList.links) as ILink)
                        }
                      >
                        {dataList.links?.at(0)?.displayText ?? localesReplacement(replacements, 'Shop online')}
                      </button>
                    )}
                  </>
                )}

              {dataList.links.filter((x) => x.isMarketing === true).length >
                0 &&
                !isFastScan && (
                  <>
                    {dataList.links.length > 1 ? (
                      <ClickOut
                        className={`${cx('trigger')} ${cx('marketing')}`}
                        onClickOut={() => {
                          setVisibleMarketing(false);
                        }}
                      >
                        <>
                          <button
                            className={`primary-button ${cx(
                              'marketing-online',
                            )}`}
                            onClick={() =>
                              setVisibleMarketing(!visibleMarketing)
                            }
                          >
                            {localesReplacement(replacements, 'Discover More')}
                          </button>

                          <div
                            className={cx(
                              'marketing-flyout',
                              {visible: visibleMarketing},
                              positionMarketing,
                            )}
                          >
                            <ul>
                              {_.sortBy(
                                dataList.links,
                                (o) => o.displayText,
                              ).map(
                                (item) =>
                                  item.isMarketing && (
                                    <li key={item.id}>
                                      <button
                                        popovertarget="external-link-popover"
                                        popoveraction="show"                                        
                                        onClick={() => openLink(item)}
                                        rel='noreferrer'
                                        target='_blank'
                                        className={`link ${cx('shop online')}`}
                                      >
                                        {localesReplacement(
                                          replacements,
                                          item.displayText,
                                        )}
                                      </button>
                                    </li>
                                  ),
                              )}
                            </ul>
                          </div>
                        </>
                      </ClickOut>
                    ) : (
                      <button
                        className={`primary-button ${cx(
                          'marketing-online',
                          'no-icon',
                        )}`}
                        popovertarget="external-link-popover"
                        popoveraction="show"
                        onClick={() =>
                          openLink(_.head(dataList.links) as ILink)
                        }
                      >
                        {localesReplacement(replacements, 'Discover More')}
                      </button>
                    )}
                  </>
                )}
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  whereToBuyEnabled: state.whereToBuyEnabled,
  locationCategoriesList: state.locationCategoriesList,
  productCategoriesList: state.productCategoriesList,
  whereToServiceEnabled: state.whereToServiceEnabled,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setProductCategories: (productCatgories: string[]) =>
    dispatch(actions.setProductCategories(productCatgories)),
  setLocationCategories: (locationCategories: string[]) =>
    dispatch(actions.setLocationCategories(locationCategories)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OilThumb);
